import axios from 'axios'
import { message } from 'antd';

export const EMAIL_REPORTS_HAS_ERROR = 'EMAIL_REPORTS_HAS_ERROR'
export const EMAIL_REPORTS_IS_LOADING = 'EMAIL_REPORTS_IS_LOADING'
export const EMAIL_REPORTS_FETCH_DATA_SUCCESS = 'EMAIL_REPORTS_FETCH_DATA_SUCCESS'
export const ADD_EMAIL_REPORTS_SUCCESS = 'ADD_EMAIL_REPORTS_SUCCESS'
export const EDIT_EMAIL_REPORTS_SUCCESS = 'EDIT_EMAIL_REPORTS_SUCCESS'
export const DELETE_EMAIL_REPORTS_SUCCESS = 'DELETE_EMAIL_REPORTS_SUCCESS'

export function emailReportsHasError(err) {
    return {
        type: EMAIL_REPORTS_HAS_ERROR,
        error: err
    };
}

export function emailReportsIsLoading(bool) {
    return {
        type: EMAIL_REPORTS_IS_LOADING,
        isLoading: bool
    };
}

export function emailReportsFetchDataSuccess(reports) {
    return {
        type: EMAIL_REPORTS_FETCH_DATA_SUCCESS,
        reports
    };
}

export function addEmailReportSuccess(report) {
    return {
        type: ADD_EMAIL_REPORTS_SUCCESS,
        report: report
    };
}

export function editEmailReportSuccess(report) {
    return {
        type: EDIT_EMAIL_REPORTS_SUCCESS,
        report: report
    };
}

export function deleteEmailReportsSuccess(items) {
    return {
        type: DELETE_EMAIL_REPORTS_SUCCESS,
        deleted_reports: items
    };
}

async function getReports(reports_url) {
    const res = await axios(reports_url);
    return res.data;
  }

export function fetchEmailReports(reports_url) {
    return (dispatch) => {
        dispatch(emailReportsIsLoading(true));
    
        getReports(reports_url)
        .then(response => {
            dispatch(emailReportsIsLoading(false));
            dispatch(emailReportsFetchDataSuccess(response));
        })
        .catch(err => {
            dispatch(emailReportsHasError(err));
        })
      } 
    }    

export function updateReport(report_url, report) {
    return (dispatch) => {
        axios.post(report_url, report)
        .then(response => {
            if (response.data.id !== undefined){
                dispatch(addEmailReportSuccess(response.data));
            }
            else {
                dispatch(editEmailReportSuccess(report));
            }
        })
        .catch(err => {
          message.error(err.message);
        })
      }  
    }  

export function deleteReportsRequest(report_url, items_to_delete) {
        return (dispatch) => {
            let promises = [];
        
            items_to_delete.forEach(item => {
            promises.push(axios.delete(report_url + "?id=" + item))
            });
        
            axios.all(promises)
            .then(response => {
                dispatch(deleteEmailReportsSuccess(items_to_delete));
        })
        .catch(err => {
          message.error(err.message);
        })
      }
    }    